import React from 'react';
import Logo from '../..//assets/images/B3logo.png';
const Spinner = () => {
  return (
    <div className="fixed inset-0 flex h-screen w-screen justify-center z-40 items-center bg-black ">
      <div className='loader2 text-2xl font-semibold text-white'>
        <div className="relative z-10 flex items-center justify-center bg-[#1c61ae] rounded-full">
          <img src={Logo} alt="Logo" className="rounded-full p-1 h-16 w-16" />
        </div>
      </div>
      <div className="loader"> </div>
      <style jsx>{`
          .loader {
              border: 2px solid #1c61ae;
              width: 80px;
              height: 80px;
              border-radius: 50%;
              border-right-color: transparent;
              animation: rot 1s linear infinite;
              box-shadow: 0px 0px 20px #1c61ae inset;
                      }
              .loader2 {
              position: absolute;
              left: 50%;      
              top: 50%;      
              transform: translate(-50%, -50%);
}


@keyframes rot {
  0% {
       transform: rotate(0deg);
     }
     100% {
       transform: rotate(360deg);
     }
}

        `}</style>

    </div>
  );
};

export default Spinner;
